import React from 'react';
import { FormControl, FormLabel, Textarea, Tooltip } from '@chakra-ui/react';

export const ProfileTextarea = ({
	w,
	state,
	setter,
	name,
	en,
	ru,
	placeholder,
	isDisabled = false,
	...props
}) => {
	const onChange = e => setter({ ...state, [e.target.name]: e.target.value });

	const tooltip = { label: ru, placement: 'top-start' };
	const textarea = {
		onChange,
		name,
		placeholder,
		value: state[name],
		isDisabled,
	};

	return (
		<FormControl w={w} {...props}>
			<Tooltip {...tooltip}>
				<FormLabel>{en}</FormLabel>
			</Tooltip>
			<Textarea {...textarea} />
		</FormControl>
	);
};
